exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".offline-badge[data-v-399fd141] {\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 3;\n}\n", ""]);

// exports
